import $ from 'jquery'
import Backbone from 'backbone'
import template from './equation-form.hbs'
import constants from 'scoreboard/components/constants'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import calendars from 'scoreboard/components/calendars'
import formHelper from 'scoreboard/components/form-helper'
import metricEquationFormatter from '../metric-equation-formatter'
import metricEquationParser from './../metric-equation-parser'
import LabelOrgScoringType from './label-org-scoring-type'
import config from 'scoreboard/components/config'
import comparisonStrings from './comparison-strings'
import messageCodeMatcher from './message-code-matcher'
import dropdown from 'scoreboard/components/dropdown'
import ReferencedObjectSelectorForm from './referenced-object-selector-form'
import sections from 'scoreboard/components/sections'
import globals from 'scoreboard/components/globals'
import appDisplay from 'scoreboard/components/app-display'
import selects from 'scoreboard/components/selects'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import MarkedField from 'scoreboard/components/marked-field'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import positiveIntegerValidator from 'scoreboard/components/validators/positive-integer-validator'
import EquationEditor from 'scoreboard/components/equations/equation-editor'
import decimalSeparatorMessage from 'scoreboard/components/decimal-separator-message'
import seriesNames from 'scoreboard/scorecards/series-names'

var seriesCodes = [
	'scorecards.node.metric.actualValue',
	'scorecards.node.metric.threshold.base',
	'scorecards.node.metric.threshold.goal',
	'scorecards.node.metric.threshold.worst',
	'scorecards.node.metric.threshold.warning',
	'scorecards.node.metric.threshold.reachout',
	'scorecards.node.metric.threshold.best',
	'scorecards.node.metric.threshold.yellowFlag',
	'scorecards.node.metric.threshold.lowtarget',
	'scorecards.node.metric.threshold.hightarget',
	'scorecards.node.metric.threshold.lowworst',
	'scorecards.node.metric.threshold.highworst',
	'scorecards.node.metric.threshold.lowbase',
	'scorecards.node.metric.threshold.highbase'
]

var aggregationCodes = [
    'scorecards.node.metric.aggregationType.sum',
    'scorecards.node.metric.aggregationType.average'
]

var calculationCodes = [
	'initiatives.calculation.daysElapsed',
	'initiatives.calculation.percentTimeElapsed',
	'initiatives.calculation.percentComplete',
	'initiatives.calculation.projectedScheduleVariance',
	'initiatives.calculation.budget',
	'initiatives.calculation.budgetSpentToDate',
	'initiatives.calculation.budgetRemaining',
	'initiatives.calculation.projectedBudget',
	'initiatives.calculation.projectedBudgetVariance',
	'initiatives.calculation.projectedBudgetVariancePercent'
]

var calculationAcronymCodes = _.map(calculationCodes, function(code) {
	return code + '.acronym'
})

var TheEquationEditor = EquationEditor.extend({

	_referenceData: function(el) {
		var data = EquationEditor.prototype._referenceData.apply(this, arguments)
		if (data.calendarId) {
			data.calendar = calendars.calendarsById[data.calendarId].label
		}
		return data
	}

})

var EquationForm = Backbone.View.extend({

	// this.model is a ScorecardNode

	// this.options.series is the name of the series, e.g.

	tagName: 'form',

	className: 'form scorecard-equation-form equation-editor',

	events: {
		'change .type': 'changeType',
		'change .period-direction': 'togglePeriodNumber',
		'click .id': 'objectSelector'
	},

	initialize: function(options) {
		this.options = options || {}
		var args = this.model ? [this.model.attributes] : []
		this._labelOrgScoringType = new LabelOrgScoringType(args)
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.renderBanner()
		// must before the call to changeType
		this._renderPeriodNumber()
		this.changeType({ target: this.$('.equation-controls') })
		dropdown.keys(this.$('.equation-controls select.calculation').empty(), calculationCodes)
		dropdown.idLabels(this.$('.equation-controls select.calendar-id').empty(), calendars.calendars,
			config.ytdCalendarId || calendars.calendars[0].id)
		this.previousType = this.$('select.type').val()

		let equation = this.getSeries(this.model).equation
		// #27765 don't display dataset equations, which are in json format
		// (possible if user switched update type from 'dataset' to 'calculated')
		if (_.startsWith(equation, '{')) {
			equation = null
		}

		this.equationEditor = new TheEquationEditor({
			el: this.el,
			equation,
			equationParser: metricEquationParser,
			equationFormatter: metricEquationFormatter
		})
		this.equationEditor.on('submit', this.submit.bind(this))
		this.equationEditor.on('edit', this.edit.bind(this))
		this.equationEditor.on('selection', this.periodNumberField.removeTooltip.bind(this.periodNumberField))
		this.equationEditor.on('render:equation', this.updateWithServerData.bind(this))
		this.equationEditor._formView.on('change', this.toggleAddEnabled.bind(this))
		// important: this goes after all the event handlers are setup
		this.equationEditor.render()

		selects(this.el.querySelectorAll('select'))
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		// Wait until the table has rendered before getting its width and setting the
		// max-width of the dialog accordingly
		this.on('opened', function() {
			this.equationEditor.referenceChange()
		})

		this.toggleAddEnabled()

		return this
	},

	context: function() {
		return _.extend({
			seriesKey: i18n.get('scorecards.node.metric.seriesKeyEquation', this.options.series)
		}, this.model.attributes)
	},

	renderBanner: function() {
		// #36115 display explanation if decimal separator for locale won't work
		// with equation syntax
		if (config.decimalSeparator != '.') {
			this.$('.banner-warning').removeClass('is-not-displayed')
			this.$('.banner-warning').html(decimalSeparatorMessage())
		}
	},

	// render the periodNumber marked field
	_renderPeriodNumber: function() {
		this.periodNumberField = new MarkedField({
			el: this.$('[name=periodNumber]'),
			dataType: 'number',
			evaluator: numericEvaluator,
			validator: [requiredValidator, positiveIntegerValidator]
		}).render()
		this.$('.period-number-container').addClass('is-not-displayed')
	},

	/**
	 * Load information about all the references initiatives and metrics from
	 * the server, and then update the display to reflect all the extra info
	 * we now know.  For example, updates the label of the domain object and
	 * the series dropdown.  Also flags any invalid references
	 */
	updateWithServerData: function() {
		var scorecardIds = []
		var initiativeIds = []
		_.each(this.equationEditor._matches, function(match) {
			var array = match.type == 'initiative' ? initiativeIds : scorecardIds
			// references like M() won't have an ID
			if (match.id) {
				array.push(match.id)
			}
		})
		// #9138 after loading all this data, take a look at what's selected
		// again and update the form controls appropriately
		this._labelOrgScoringType.load(scorecardIds, initiativeIds, results => {
			if (results) {
				this.equationProjectData = results
			}
			this.equationEditor.selection()
			this.validateReferences()
		})
	},

	/**
	 * Validates all the references in the equation, and flags any that are
	 * invalid (i.e. turns them red)
	 */
	validateReferences: function(scorecardIds, initiativeIds) {
		var code
		_.each(this.equationEditor._matches, function(match) {
			var domainType = this.getDomainTypeFromReferenceType(match.type)
			var id = match.id
			// handle equations like M(), M(-1p), T(Goal) where the metric being
			// referenced is the current metric
			if (_.isNil(id) &&
				(match.type === 'metric' || match.type === 'threshold')) {
				id = this.model.id
			}
			var node = this._labelOrgScoringType.get(domainType, id)
			if (node) {
				if (domainType === 'scorecard-item' && !node.scoringTypeId &&
					match.type != 'score') {
					// TODO: add button error about only metrics allowed in
					// equations, using code admin.scorecards.metric.equation.invalid.metric

					// non-metric found, so display error.  Note scores in
					// equations can reference any scorecard item
					this.markInvalidReference(match)
				}
				if (domainType === 'scorecard-item' && match.type != 'score') {
					// #47456 disallow kpis with custom text scoring types
					let scoringType = config.scoringType(node.scoringTypeId)
					let customText = _.get(scoringType, 'isCustomText', false)
					if (customText) {
						this.markInvalidReference(match)
					}
				}
			} else {
				// we couldn't find the domain object they referenced
				this.markInvalidReference(match)
			}
			if (match.calculation) {
				code = messageCodeMatcher.codeForInput(calculationAcronymCodes, match.calculation)
				if (!code) {
					// we couldn't find a matching init calculation
					this.markInvalidReference(match)
				}
			}
			if (match.series && match.type !== 'score') {
				code = messageCodeMatcher.codeForInput(seriesCodes, match.series)
				// #47855 for non-standard scoring types, use the scoring
				// type's threshold names to check user input instead of the
				// standard seriesCodes
				let scoringType = config.scoringType(node.scoringTypeId)
				if (_.isNil(_.get(scoringType, 'standardScoringType'))) {
					let keys = scoringType.thresholdNames.concat(constants.ACTUAL_VALUE)
					code = messageCodeMatcher.codeForInput(keys, match.series)
				}
				if (!code) {
					// we couldn't find a matching series for a metric or
					// threshold reference
					this.markInvalidReference(match)
				}
			}
			if (match.aggregation) {
				code = messageCodeMatcher.codeForInput(aggregationCodes, match.aggregation)
				if (!code) {
					// we couldn't find a matching aggregation for a TD reference
					this.markInvalidReference(match)
				}
			}
			if (match.calendar) {
				var calendar = this.findCalendar(match.calendar)
				if (!calendar) {
					// we couldn't find a matching calendar for a TD reference
					this.markInvalidReference(match)
				}
			}
		}.bind(this))
	},

	markInvalidReference: function(match) {
		this.$('.reference[data-type=' + match.type + '][data-id=' + match.id + ']').addClass('is-invalid')
	},

	// retrieves a domain object based on the given match.  only examines nodes that are
	// already cached by the labelOrgScoringType component
	_getDomainObject: function(match) {
		var type = match.type === 'initiative' ? 'initiative' : 'scorecard-item'
		var id = match.id
		if (!id && (match.type === 'metric' || match.type == 'threshold')) {
			id = this.model.id
		}
		return this._labelOrgScoringType.get(type, id)
	},

	// show or hide the period number dropdown as appropriate
	togglePeriodNumber: function(e) {
		var row = $(e.target).closest('tr')
		var direction = row.find('select.period-direction').val()
		var showPeriodNumber = 'common.current' !== direction

		this.$('.period-number-container').toggleClass('is-not-displayed', !showPeriodNumber)
		if (!showPeriodNumber) {
			this.periodNumberField.removeTooltip()
		}
	},

	// render the contents of the given series dropdown
	renderSeries: function(select, id, value) {
		var self = this
		if (_.isNil(id)) {
			var scoringType = config.scoringType(this.model.get('scoringTypeId'))
			var keys = [constants.ACTUAL_VALUE]
			keys = keys.concat(scoringType.thresholdNames)
			value = messageCodeMatcher.codeForInput(keys, value) || constants.ACTUAL_VALUE
			dropdown.keys(select.empty(), keys, value)
			return
		}

		this._labelOrgScoringType.load([id], null, function() {
			var sn = self._labelOrgScoringType.get('scorecard-item', id)
			var keys = [constants.ACTUAL_VALUE]
			if (sn) {
				var scoringType = config.scoringType(sn.scoringTypeId)
				if (scoringType && !_.isEmpty(scoringType.thresholdNames)) {
					keys = keys.concat(scoringType.thresholdNames)
				}
			}
			value = messageCodeMatcher.codeForInput(keys, value) || constants.ACTUAL_VALUE
			dropdown.keys(select.empty(), keys, value)
		})
	},

	// update the form controls to be appropriate for the type (metric, td, etc)
	// optionally also change the type to the given value
	changeType: function(e) {
		var row = $(e.target).closest('tr')
		var tableCell = row.find('td')
		var type = row.find('select.type').val()
		var labelText = tableCell.find('.label-text.' + type)

		// show dropdowns appropriate for the selected type
		tableCell.has('.metric, .initiative, .td, .score').toggleClass('is-not-displayed', true)
		tableCell.has('.' + type).toggleClass('is-not-displayed', false)

		// Show the correct label for each option
		labelText.siblings('.label-text').toggleClass('is-not-displayed', true)
		labelText.toggleClass('is-not-displayed', false)

		var idEl = row.find('.id')
		var differentSections = this._section(type) != this._section(this.previousType)
		// #53495 after switching sections, doesn't make sense to keep id around
		if (differentSections) {
			idEl.val('')
		}
		var invalidId = _.isEmpty(idEl.val()) && type != 'metric'
		if (invalidId) {
			idEl.val('')
		}
		if (invalidId || _.isEmpty(idEl.find('.label').text()) ||
			this._section(type) != this._section(this.previousType)) {
			if (type === 'score') {
				idEl.find('.label').text(i18n.get('alerts.selectAScorecardObject'))
			} else if (this._section(type) === 'scorecards') {
				idEl.find('.label').text(i18n.get('scorecards.node.metric.select'))
			} else {
				idEl.find('.label').text(i18n.get('initiatives.initiative.select'))
			}
		}
		this.togglePeriodNumber(e)

		// #8302 need to clear errors when switching types
		_.result(this.periodNumberField, 'clearError')

		this.previousType = type
	},

	// returns the section based on a reference type
	_section: function(type) {
		return type === 'initiative' ? 'initiatives' : 'scorecards'
	},

	// load the data for a scorecard node and populate its series dropdown
	changeId: function(row, id, value) {
		var type = row.find('select.type').val()
		var metricIds = 'initiative' === type ? [] : [id]
		var initiativeIds = 'initiative' === type ? [id] : []
		if ('metric' === type) {
			this.renderSeries(row.find('select.series'), id, value)
		}
		this._labelOrgScoringType.load(metricIds, initiativeIds, function() {
			var domainType = this.getDomainTypeFromReferenceType(type)
			var node = this._labelOrgScoringType.get(domainType, id)
			var idEl = row.find('.id')
			var text = idEl.find('.label').text()
			if (node) {
				idEl.val(node.id)
				text += ' ' + node.label
			}
			idEl.find('.label').text(text)
		}.bind(this))
	},

	getDomainTypeFromReferenceType: function(type) {
		return type === 'initiative' ? 'initiative' : 'scorecard-item'
	},

	objectSelector: function(e) {
		if (this._selectObjectTooltip) {
			this._removeSelectMetricTooltip()
			return
		}

		var self = this
		var row = $(e.target).closest('tr')
		var idEl = row.find('.id')
		var id = idEl.val()
		var type = row.find('select.type').val()
		var sec = this._section(type)
		var domainType = sections.toType(sec)
		var projectId

		// Figure out the project id of the selected equation part (if there is one)
		var updateEquationData = (id, pid) => {
			if (_.isNil(this.equationProjectData)) {
				return
			}

			let updateExisting
			for (var i = 0; i < this.equationProjectData.length; i++) {
				if (this.equationProjectData[i].id == id) {
					projectId = pid || this.equationProjectData[i].projectId
					updateExisting = true
				}
			}

			if (!updateExisting) {
				this.equationProjectData.push({
					id: id,
					projectId: pid
				})
			}
		}

		updateEquationData(id)

		var options = {
			title: row.find('.equation-type-selector').text(),
			id: id,
			orgId: id ? null : globals.orgId,
			section: sec,
			type,
			thisMetric: type === 'metric',
			projectId,
			params: {
				// #47456 scoring type is needed so we can disable metrics with
				// custom text scoring type
				scoringType: true
			}
		}

		var dialog = new ReferencedObjectSelectorForm(options)
		appDisplay.dialog(dialog)

		dialog.on('select', function(object) {
			dialog.trigger('done')
			var initTypes = ['initiative', 'task', 'milestone']
			var allowedObjectType =
				// if a metric was chosen, that's fine
				object.type === 'metric' ||
				// if an initiative type was chosen, that's fine
				_.indexOf(initTypes, object.type) != -1 ||
				// if this is a score reference, any object type is fine
				type === 'score'
			if (allowedObjectType) {
				this.selectObject(idEl, object)
				this.renderSeries(row.find('select.series'), object.id)
				this._removeSelectMetricTooltip()
				this.toggleAddEnabled()
			}
			// The width of the button changes depending on the text, so we
			// need to recalculate the table width and adjust the dialog width.
			// Pass in `true` so the reference is adjusted after each change.
			this.equationEditor.referenceChange(true)

			// update this.equationProjectData with the proper projectId in case it changed
			updateEquationData(object.id, object.projectId)
		}.bind(this))

		function selectOrg() {
			var si = self._labelOrgScoringType.get(domainType, id)
			if (si) {
				dialog.objectSelector.selectOrg(si.organizationId)
			}
		}

		if (id) {
			// use the object ID to figure out the org ID.  May involve sending
			// a request to the server
			if (self._labelOrgScoringType.get(domainType, id)) {
				selectOrg()
			} else {
				var metricIds = sec == 'scorecards' ? [id] : null
				var initiativeIds = sec == 'initiatives' ? [id] : null
				this._labelOrgScoringType.load(metricIds, initiativeIds, selectOrg)
			}
		} else {
			// if no object ID, default to the current org ID
			dialog.objectSelector.selectOrg(globals.orgId)
		}
	},

	selectObject: function(idEl, object) {
		if (object.id) {
			idEl.find('.label').text('(' + object.id + ') ' + (object.label || ''))
			if (object.label) {
				idEl.val(object.id)
			}
		} else {
			var key
			if (object.thisMetric) {
				key = 'scorecards.node.metric.this'
			} else {
				if (object.type === 'initiative') {
					key = 'initiatives.initiative.select'
				} else if (object.type === 'score') {
					key = 'alerts.selectAScorecardObject'
				} else {
					key = 'scorecards.node.metric.select'
				}
			}
			idEl.val('').find('.label').text(i18n.get(key))
		}
	},

	// creates a context to pass into one of our row templates
	_matchContext: function(match) {
		var context = _.clone(match)
		// the label may not be loaded yet, but if it is already loaded let's
		// go ahead and set it here to minimize flicker
		match.label = _.result(this._getDomainObject(match), 'label')
		return match
	},

	// edit an existing reference, e.g. M(1), using gui controls
	edit: function(match) {
		var row = this.$('.equation-controls')
		var data = _.clone(match)
		if (data.calculation) {
			data.calculation = messageCodeMatcher.codeForInput(calculationAcronymCodes, data.calculation)
			if (data.calculation) {
				data.calculation = data.calculation.replace('.acronym', '')
			}
		}
		if (data.series) {
			// #49891 add any threshold names for the scoring type of the
			// match to the array of standard series codes so
			// data.series will be populated correctly for custom scoring types
			let keys = _.concat([], seriesCodes)
			let domainType = this.getDomainTypeFromReferenceType(data.type)
			// look up the node stored in this._labelOrgScoringType
			let node = this._labelOrgScoringType.get(domainType, data.id)
			// get any threshold names (returns [] if not found)
			let thresholds = seriesNames(_.get(node, 'scoringTypeId'))
			keys = _.concat(thresholds, keys)
			data.series = messageCodeMatcher.codeForInput(keys, data.series)
		}
		if (data.aggregation) {
			data.aggregation = messageCodeMatcher.codeForInput(aggregationCodes, data.aggregation)
		}
		_.defaults(data, {
			periodDirection: 'common.current',
			aggregation: constants.AGGREGATIONTYPE_SUM_CODE,
			series: constants.ACTUAL_VALUE,
			calculation: calculationCodes[0]
		})

		// #53496 if the match is 'M()' (this metric), indicate this so that it
		// stays selected
		if (this.isThisMetric()) data.thisMetric = true

		// thresholds actually have "Metric" chosen in the type dropdown
		if (data.type === 'threshold') {
			data.type = 'metric'
		}
		this.renderSeries(row.find('select.series'), data.id, data.series)
		var calendar = this.findCalendar(data.calendar)
		var id = calendar ? calendar.id : calendars.calendars[0].id
		row.find('select.calendar-id').val(id)
		selects.update(this.$('select.calendar-id'))

		// write this after all the dropdowns are populated
		formHelper.writeToDom(data, row)
		// this must be after formHelper.writeToDom but before this.changeId
		this.changeType({ target: row })
		// handle ID after writeToDom b/c writeToDom messes up the ID display
		this.selectObject(row.find('.id'), data)
		// #12916 be sure to specify the series!
		this.changeId(row, data.id, data.series)
	},

	/**
	 * Finds a calendar matching the user's input, if possible.  Otherwise,
	 * returns null.
	 */
	findCalendar: function(userInput) {
		return _.find(calendars.calendars, function(calendar) {
			return comparisonStrings.get(calendar.label) == comparisonStrings.get(userInput)
		})
	},

	/**
	 * toggles whether the add button should be enabled based on the
	 * the state of the form controls (e.g. has a valid metric been chosen?)
	 */
	toggleAddEnabled: function() {
		var idChosen = !isNaN(parseInt(this.$('.id').val()))
		// whether "This Metric" is a valid option and was chosen
		var thisMetric = this.isThisMetric()
		var valid = (idChosen || thisMetric)
		this.$('button.add').prop('disabled', !valid)
	},

	'delete': function(e) {
		var row = $(e.target).closest('tr')
		this.$('.reference').eq(row.index()).remove()
		row.remove()
	},

	/**
	 * For the series being edited, returns the corresponding series object
	 * from the provided model
	 * @param {ScorecardNode} sn the model of the scorecard node
	 */
	getSeries: function(sn) {
		var series
		if (this.options.series === constants.ACTUAL_VALUE) {
			series = sn.get('series')[0]
		} else {
			var scoringType = config.scoringType(sn.get('scoringTypeId'))
			_.each(scoringType.thresholdNames, function(key, index) {
				if (key === this.options.series) {
					// +1 since the actual is at index 0
					series = sn.get('series')[index+1]
					// stop looping
					return false
				}
			}.bind(this))
		}
		return series
	},

	isThisMetric: function() {
		return this.$('select.type').val() === 'metric' &&
			_.trim(this.$('.id').text()) === i18n.get('scorecards.node.metric.this')
	},

	submit: function(e) {
		this._removeSelectMetricTooltip()
		this.equationEditor._formView.primaryButton.loading()

		// construct the scorecard node to send to the server
		var sn = this.model.clone()
		// #13052 the rest of this file expects the type to be 'scorecard-item'
		// (vs. 'initiative'), but when submitting to the server we need a
		// valid ScorecardItemType
		sn.set('type', 'metric')
		var equation = this.equationEditor.getCleanEquation()
		var series = this.getSeries(sn)
		series.equation = equation
		series.updateType = 'calculated'

		var url = 'api/scorecards/validate-equation'
		$.post({
			url,
			data: JSON.stringify(sn.attributes),
			success: (response)=> {
				if (_.isEmpty(response)) {
					this.trigger('done', equation)
				} else {
					// handle any bind errors from metricValidator.validateEnterMetricEquation
					var firstError = _.head(response.errors)
					// #13196 see if there is a singular version of this message,
					// and if so display that.  For example, "The equation is
					// invalid" instead of "One or more equations was invalid".
					var message
					var singularCode = firstError.messageCode + '.singular'
					if (i18n.hasKey(singularCode)) {
						var args = [singularCode].concat(firstError.arguments || [])
						message = i18n.get.apply(i18n, args)
					} else {
						message = i18n.get(firstError.message)
					}
					this.equationEditor._formView.errorMessage(message)
					this.equationEditor._formView.primaryButton.disable()
				}
			},
			error: xhr => {
				// #56335 handle any non-bind errors for invalid equations
				// (ex. an equation that can't be parsed), so the error
				// message can be clicked to display the stack trace
				this.equationEditor._formView.error(xhr)
			}
		})
	},

	_removeSelectMetricTooltip: function() {
		if (this._selectObjectTooltip) {
			this._selectObjectTooltip.remove()
			delete this._selectObjectTooltip
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._functionsTooltip, this.equationEditor,
			this._selectObjectTooltip, this.covertButtonTooltips,
			this.periodNumberField], 'remove')
	}

})

export default EquationForm

EquationForm.__filename__ = 'scorecards/edit/equation-form.js'
